

<template>
  <DBox :id="'cmp-distribution-order-delivery_address'" :addButton="false">
    <DatePicker2
      id="shipping_date"
      :label="$dft.capHead($t('shipping Date'))"
      :disabled="selectedOrder.order_details_tab_summary_loading"
      :value="
        selectedOrder &&
        selectedOrder.order_details_tab_summary &&
        selectedOrder.order_details_tab_summary.order &&
        selectedOrder.order_details_tab_summary.order.shipping_date
      "
      @input="(e) => onTextFieldValueChange(e)"
    />
    <div class="ut-flex">
      <TextField2
        id="order_discount"
        :placeholder="`${$dft.capHead($t('discount'))} in %`"
        :label="`${$dft.capHead($t('discount'))} in %`"
        :disabled="selectedOrder.order_details_tab_summary_loading"
        ta="'left'"
        :cw="`clamp(30px, ${
          (
            (selectedOrder &&
              selectedOrder.order_details_tab_summary &&
              selectedOrder.order_details_tab_summary.order &&
              selectedOrder.order_details_tab_summary.order.order_discount) ||
            'discountpe'
          ).toString().length * 13
        }px, 450px)`"
        :type="'percent'"
        :value="
          selectedOrder &&
          selectedOrder.order_details_tab_summary &&
          selectedOrder.order_details_tab_summary.order &&
          selectedOrder.order_details_tab_summary.order.order_discount
        "
        @blur="(e) => onTextFieldValueChange(e)"
        :bb="'0px'"
      />
      <div class="ut-text-right" style="flex: 1; margin-right: 10px"> {{ $dft.curr(-1 * selectedOrder.discount_amount) }}
        {{ selectedOrder.orderCurrency }}
         </div>
    </div>
    <!-- <TextField2
      id="order_discount"
      :placeholder="`${$dft.capHead($t('discount'))} in %`"
      :label="`${$dft.capHead($t('discount'))} in %`"
      :disabled="selectedOrder.order_details_tab_summary_loading"
      :value="
        selectedOrder &&
        selectedOrder.order_details_tab_summary &&
        selectedOrder.order_details_tab_summary.order &&
        selectedOrder.order_details_tab_summary.order.order_discount
      "
      @blur="(e) => onTextFieldValueChange(e)"
      :bb="'0px'"
    /> -->
  </DBox>
</template>

<script>
export default {
  props: {
    selectedOrder: {
      type: Object,
    },
  },
  methods: {
    onTextFieldValueChange: function (e) {
      const payload = {
        name: e.name,
        value: e.value,
      };
      this.$emit("changed", payload);
    },
  },
};
</script>
